module.exports = __webpack_public_path__ + "static/media/about-us-image.c2539bec.png";